// Whether to suggest a visitor the page they are on in the site's other
// language. The browser's languages say what the visitor reads; where they
// are does not (an Italian abroad, an English speaker in Milan). Google asks
// sites to offer the other version rather than redirect to it, so search
// engines and visitors still reach both:
// https://developers.google.com/search/docs/specialty/international/managing-multi-regional-sites

const ANSWERED = "avrah.languageSuggestionAnswered";

// The site's language to suggest a visitor on a page in `pageLang`, given
// the languages their browser asks for, most wanted first
// (navigator.languages); null when the page is already in it. A visitor
// who reads neither of the site's languages is offered English.
export function suggestedLanguage(browserLanguages, pageLang) {
  if (!browserLanguages?.length) return null;
  const read = browserLanguages
    .map((tag) => tag.slice(0, 2).toLowerCase())
    .find((code) => code === "it" || code === "en") ?? "en";
  return read === pageLang ? null : read;
}

// Whether the visitor has answered the suggestion, or picked a language
// themselves. Where storage cannot be read, their answer could not be kept
// and the suggestion would come back on every page, so it is not made at
// all. Storage that reads but refuses the answer (a full quota) brings the
// card back on the next page; answerLanguageSuggestion logs that.
export function languageSuggestionAnswered() {
  try {
    return window.localStorage.getItem(ANSWERED) === "true";
  } catch {
    return true;
  }
}

export function answerLanguageSuggestion() {
  try {
    window.localStorage.setItem(ANSWERED, "true");
  } catch (error) {
    console.warn("The visitor's choice of language could not be kept:", error);
  }
}
